import type { VoidFunctionComponent } from 'react';

import type { CheckRevisionResponse } from '../../../../../shared/revisions/types';

import Invalid from './Invalid';
import Loading from './Loading';
import Metadata from './Metadata';

import styles from './index.module.less';

export type Props = {
  metadata?: CheckRevisionResponse;
  isLoading?: boolean;
  isInvalid?: boolean;
};

/**
 * A multi-state card component used to display the results of testing if a
 * dependency revision has been resolved (or can be resolved) by FOSSA.
 */
const TestDependencyCard: VoidFunctionComponent<Props> = ({ metadata, isLoading, isInvalid }) => {
  const renderContent = () => {
    if (isLoading) {
      return <Loading />;
    }

    if (isInvalid || !metadata) {
      return <Invalid />;
    }

    return <Metadata metadata={metadata} />;
  };

  return (
    <div className={styles.card}>
      {renderContent()}
    </div>
  );
};

export default TestDependencyCard;
